"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "I18n", {
  enumerable: true,
  get: function get() {
    return _i18n["default"];
  }
});
Object.defineProperty(exports, "translate", {
  enumerable: true,
  get: function get() {
    return _translate["default"];
  }
});
Object.defineProperty(exports, "useTranslate", {
  enumerable: true,
  get: function get() {
    return _useTranslate["default"];
  }
});

var _i18n = _interopRequireDefault(require("./i18n"));

var _translate = _interopRequireDefault(require("./translate"));

var _useTranslate = _interopRequireDefault(require("./useTranslate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }